<template>
  <div class="container-fluid">
    <div class="row justify-content-md-center">
      <h4><a @click="subMonth">&lt;&lt;前月</a> &nbsp; {{ year }}年 {{ month }}月 &nbsp;<a @click="addMonth">翌月&gt;&gt;</a></h4>
    </div>
    <div class="row">
      <div class="col col-4">
        <form>
          <div class="form-group">
            <h3>店舗を選択してください</h3>
            <div class="form-check" v-for="shop in shops">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="selectedShops" @change="changeShop" :value="shop.pk">{{ shop.code }}: {{ shop.name }}</input>
              </label>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="row">
      <div class="col col-12">
        <div class="table-view">
          <table class="shift-table table table-headerfixed table-bordered table-striped" v-if="selectedShops.length">
            <thead>
              <tr>
                <th v-bind:style="tableShopStyle(shop)" v-for="shop in selectedShops" :key="shop" v-show="staffLength(shop)" :colspan="staffLength(shop) + 1">
                  {{ printShopName(shop) }}
                </th>
              </tr>
              <tr>
                <template v-for="shop in selectedShops" :key="shop" v-show="staffLength(shop)">
                  <th class="shift-table-title">日付</th>
                  <th class="shift-table-title" width="120" v-for="staff in staffs[shop]">
                    {{ staff.name }}
                  </th>
                </template>
              </tr>
            </thead>
            <tbody v-bind:style="tableTbodyStyle">
              <tr v-for="date in monthDates" :class="shiftClass(date)">
                <template v-for="shop in selectedShops" :key="shop" v-show="staffLength(shop)">
                  <td>{{ printDate(date) }}</td>
                  <td v-for="staff in staffs[shop]">
                    {{ printShift(date, shop, staff) }}
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'

export default {
  name: 'shift',
  data () {
    return {
      selectedShop: '',
      selectedShops: [],
      shops: [],
      staffs: {},
      shifts: {},
      year: null,
      month: null,
      today: null,
    }
  },
  computed: {
    tableStyle () {
      return {
        // width: this.tableWidth + 'px',
      }
    },
    tableTbodyStyle () {
      let height = window.innerHeight - 150
      return {
        height: height + 'px',
        // width: (this.tableWidth + 17) + 'px',
      }
    },
    tableWidth () {
      return (10 + Object.keys(this.staffs).length) * 150
    },
    monthDates () {
      let ret = []
      let start = moment(`${this.year}-${this.month}-01`).startOf('month')
      while (start <= moment(`${this.year}-${this.month}-01`).endOf('month')) {
        ret.push(start.format('YYYY/MM/DD'))
        start.add(1, 'days')
      }
      return ret
    },
  },
  methods: {
    tableShopStyle (shop) {
      return {
        'text-align': 'center',
        // width: this.staffLenght(shop) * this.tableWidth + 'pk',
      }
    },
    addMonth () {
      this.today = this.today.add(1, 'months')
      this.year = this.today.format('YYYY')
      this.month = this.today.format('MM')
      this.fetchShiftData()
    },
    subMonth () {
      this.today = this.today.add(-1, 'months')
      this.year = this.today.format('YYYY')
      this.month = this.today.format('MM')
      this.fetchShiftData()
    },
    printDate (date) {
      return  moment(date).locale('ja').format('MM/DD (ddd)')
    },
    printShopName (shopPk) {
      let shop = this.shops.find(x => x.pk === shopPk)
      return `${shop.name} (${shop.defaultOpenTime} - ${shop.defaultCloseTime})`
    },
    printShift (date, shop, staff) {
      let target = this.shifts.find(x => moment(x.date).isSame(date) && x.staff === staff.pk && x.shop === shop)
      if (!target || target.isVacation || target.isPaidVacation) {
        return ' '
      }
      let shopData = this.shops.find(x => x.pk === shop)
      let start = target.startTime
      let end = target.endTime
      if (start === shopData.defaultOpenTime && end === shopData.defaultCloseTime) {
        return '○'
      } else if (start === shopData.defaultOpenTime) {
        return `-${end}`
      } else if (end === shopData.defaultCloseTime) {
        return `${start}-`
      } else {
        return `${start}〜${end}`
      }
    },
    shiftClass (date) {
      let weekday = moment(date).day()
      if (weekday === 0) {
        return 'sunday'
      } else if (weekday === 6) {
        return 'saturday'
      }
    },
    changeShop (event) {
      this.fetchShiftData()
    },
    fetchShiftData () {
      if (!this.selectedShops || this.selectedShops.length == 0) {
        return
      }
      this.staffs = {}
      this.shifts = {}
      let param = {
        shops: this.selectedShops,
      }
      this.apiGet(`/api/1.0/shifts/calendar/${this.year}/${this.month}/`, param).then(response => {
        this.shifts = response.body.results
        this.selectedShops.forEach(shop => {
          let k = {}
          this.shifts.filter(x => x.shop === shop).forEach(shift => {
            if (k[shift.staff]) {
              return true
            }
            k[shift.staff] = true
            if (!this.staffs[shop]) {
              Vue.set(this.staffs, shop, [])
            }
            this.staffs[shop].push({
              pk: shift.staff,
              name: shift._embedded.staff.name,
              shopPk: shop,
            })
          })
        })
        return response
      })
    },
    shopStaffs (shop) {
      return []
    },
    staffLength (shop) {
      if (this.staffs[shop]) {
        return this.staffs[shop].length
      }
      return 0
    },
  },
  ready () {
    this.today = moment()
    this.year = moment().format('YYYY')
    this.month = moment().format('MM')
    this.apiGet(`/api/1.0/shops/info`, {page_size: -1}).then(response => {
      this.shops = response.body.results
    })
  },
  mixins: [
    require('mixin/api-client.vue'),
  ],
}
</script>

<style scoped>
div.container-fluid {
  margin: 20px;
}

table {
  margin: 20px;
}



.sunday {
  background-color: #ffc0cb !important;
}

.saturday {
  background-color: #87cefa !important;
}

.shift-table {
  font-size: small;
}

.shift-table.table > tbody > tr >th,
.shift-table.table > tbody > tr >td {
  padding: 2px;
}

table.table-headerfixed td {
  width: 120px;
}

div.table-view {
  overflow: scroll;
}

/*
.shift-table thead {
}

.shift-table-title {
  width: 150px;
  max-width: 150px;
}

table.table-headerfixed {
}

table.table-headerfixed thead,
table.table-headerfixed tbody,
table.table-headerfixed tr,
table.table-headerfixed td,
table.table-headerfixed th {
    display: block;
}

table.table-headerfixed tr:after {
    content: ' ';
    display: block;
    visibility: hidden;
    clear: both;
}

table.table-headerfixed td,
table.table-headerfixed th {
    width: 150px;
}

table.table-headerfixed tbody {
    height: 500px;
    overflow-y: scroll;
}

table.table-headerfixed thead {
    width: 97%;
    width: calc(100% - 17px);
}
*/

table.table-headerfixed tbody td,
table.table-headerfixed thead th {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

</style>



// WEBPACK FOOTER //
// shift.vue?2dd2419a